import styled from 'styled-components';
import { border1 } from 'utils/style/colors';

export const Directs = styled('section')`
  flex: 1;
  display: flex;
  min-height: 0;
  flex-direction: column;
`;

export const DirectBody = styled('div')`
  height: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: space-around;
`;

interface ContainerProps {
  hideOnSmall: boolean;
}
export const ChatBodyContainer = styled('section')<ContainerProps>`
  width: 100%;
  overflow: hidden;
  border: ${border1};
  display: flex;
  position: relative;
  background: var(--exact-white);
  margin-right: 1rem;
  border-radius: 10px;
  @media only screen and (max-width: 720px) {
    display: ${(props) => (props.hideOnSmall ? 'none' : 'flex')};
  }
`;
